/** Shared dark-mode tokens for DTSA marketing sections (Kingdom green palette) */
export const SA_PRIMARY = "#36923A";
export const SA_SECONDARY = "#73AD39";
export const SA_ACCENT = "#5ab030";

export const DARK_OVERLAY_STRONG =
  "linear-gradient(180deg, rgba(5, 27, 21, 0.55) 0%, rgba(5, 27, 21, 0.88) 100%)";

export const saGradientLine = {
  background: `linear-gradient(90deg, ${SA_PRIMARY}, ${SA_SECONDARY})`,
};

export const saCardBg = "rgba(5, 27, 21, 0.82)";
export const saCardBgHover = "rgba(5, 27, 21, 0.94)";
export const saCardBorder = "1px solid rgba(255, 255, 255, 0.18)";

export const saReadableText = {
  color: "rgba(255, 255, 255, 0.95)",
  textShadow: "0 1px 3px rgba(0, 0, 0, 0.8)",
};

export const saMutedText = {
  color: "rgba(255, 255, 255, 0.82)",
  textShadow: "0 1px 2px rgba(0, 0, 0, 0.6)",
};

export const saGradientTitleStyle = {
  background: `linear-gradient(135deg, ${SA_PRIMARY} 0%, ${SA_SECONDARY} 100%)`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const saDarkCardBase = {
  background: saCardBg,
  backdropFilter: "blur(12px)",
  border: saCardBorder,
};

export function darkSectionBg(image, fixed = true) {
  return {
    backgroundImage: `${DARK_OVERLAY_STRONG}, url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: fixed ? "fixed" : "scroll",
  };
}

export function onDarkCardEnter(e, accent = SA_PRIMARY) {
  e.currentTarget.style.background = saCardBgHover;
  e.currentTarget.style.borderColor = `${accent}66`;
  e.currentTarget.style.transform = "translateY(-4px)";
  e.currentTarget.style.boxShadow = `0 16px 40px ${accent}33`;
}

export function onDarkCardLeave(e) {
  e.currentTarget.style.background = saCardBg;
  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.18)";
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "none";
}
